export default __webpack_public_path__ + "static/N0277-d2275f76815a11f655f35d5d80915da9.png";